import {
  GETALL_USERS_SUCCESS,
  GETALL_USERS_FAIL,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAIL,
  EDIT_CLIENT_SUCCESS,
  EDIT_CLIENT_FAIL,
  DISABLE_CLIENT_SUCCESS,
  DISABLE_CLIENT_FAIL,
  ENABLE_CLIENT_SUCCESS,
  ENABLE_CLIENT_FAIL,
  SET_MESSAGE,
} from "./types";

import ClientService from "../services/client.service";

export const createClient = (objClient) => (dispatch) => {
  return ClientService.createClient(objClient).then(
    (response) => {
      dispatch({
        type: CREATE_CLIENT_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: CREATE_CLIENT_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const editClient = (objClient) => (dispatch) => {
  return ClientService.editClient(objClient).then(
    (response) => {
      dispatch({
        type: EDIT_CLIENT_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: EDIT_CLIENT_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const getAllUsers = () => (dispatch) => {
  return ClientService.getAllUsers().then(
    (response) => {
      dispatch({
        type: GETALL_USERS_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: GETALL_USERS_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const disableClient = (clientId) => (dispatch) => {
  return ClientService.disableClient(clientId).then(
    (response) => {
      dispatch({
        type: DISABLE_CLIENT_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: DISABLE_CLIENT_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const enableClient = (clientId) => (dispatch) => {
  return ClientService.enableClient(clientId).then(
    (response) => {
      dispatch({
        type: ENABLE_CLIENT_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: ENABLE_CLIENT_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const getClient = (clientId) => (dispatch) => {
  return ClientService.getClient(clientId)
};

export const assignPermission = (objPermission) => (dispatch) => {
  return ClientService.addPermission(objPermission).then(
    (response) => {
      dispatch({
        type: EDIT_CLIENT_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: EDIT_CLIENT_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};